import { composeWithDevTools } from "@redux-devtools/extension";
import { applyMiddleware, legacy_createStore as createStore } from "redux";
import { createLogger } from "redux-logger";
import { thunk } from "redux-thunk";
import useSSR from "use-ssr";

import { setInitialFilteringState } from "./filtering/actions";
import { rootReducer } from "./rootreducer";

const { isServer } = useSSR();

/* The dev branch must stay behind a static NODE_ENV check so redux-logger and
   the devtools compose are dead-code-eliminated from production bundles. */
export const configureStore = (preloadState) => {
	const store =
		process.env.NODE_ENV === "development" && !isServer
			? createStore(
					rootReducer,
					preloadState,
					composeWithDevTools(applyMiddleware(thunk, createLogger())),
				)
			: createStore(rootReducer, preloadState, applyMiddleware(thunk));

	store.dispatch(setInitialFilteringState());

	return store;
};
